export const version = "random/5.3.0";
//# sourceMappingURL=_version.js.map